import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const WorkFlowReport = createAsyncThunk(
  "WorkFlowReport/WorkFlowReport",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WorkFlowReport/WorkFlowReport",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
     
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const ValidateWorkFlow = createAsyncThunk(
    "ValidationAllPageReport/ValidateWorkFlow",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/WorkFlowReport/ValidateWorkFlow",
          parameters
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
       
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


const WorkFlowReducer = createSlice({
  name: "WorkFlowReducer",
  initialState: {
    WorkFlowResult: [],
    loadingWorkFlowResult: false,
    errorWorkFlowResult: null,
    //////////////////////////////////////
    ValidateWorkFlow: [],
    loadingValidateWorkFlow: false,
    errorValidateWorkFlow: null,
  },
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(WorkFlowReport.pending, (state, action) => {
        state.loadingWorkFlowResult = true;
        state.WorkFlowResult = action.payload;
        state.errorWorkFlowResult = null;
      })
      .addCase(WorkFlowReport.fulfilled, (state, action) => {
        state.loadingWorkFlowResult = false;
        state.WorkFlowResult = action.payload; // Assuming payload has the desired data
      })
      .addCase(WorkFlowReport.rejected, (state, action) => {
        state.loadingWorkFlowResult = false;
        state.errorWorkFlowResult = action.payload;
      });
      /////////////////////////////////////////////
      builder
      .addCase(ValidateWorkFlow.pending, (state, action) => {
        state.loadingValidateWorkFlow = true;
        state.ValidateWorkFlow = action.payload;
        state.errorValidateWorkFlow = null;
      })
      .addCase(ValidateWorkFlow.fulfilled, (state, action) => {
        state.loadingValidateWorkFlow = false;
        state.ValidateWorkFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateWorkFlow.rejected, (state, action) => {
        state.loadingValidateWorkFlow = false;
        state.errorValidateWorkFlow = action.payload;
      });
  },
});


export default WorkFlowReducer.reducer;
